import React, { useEffect, useState } from "react";
import PropTypes from "prop-types"

function UIMultiselect(props) {
    const [selectedKeys, setSelectedKeys] = useState([]);

    const selectValue = (key) => {
        console.log(key)
        let tmpSelectedKeys = structuredClone(selectedKeys);
        if (selectedKeys.includes(key)) {
            const i = tmpSelectedKeys.indexOf(key);
            tmpSelectedKeys.splice(i, 1);
        } else {
            tmpSelectedKeys.push(key);
        }

        setSelectedKeys(tmpSelectedKeys);
        console.log(tmpSelectedKeys)
    }

    useEffect(() => {
        if (props.getKeyValue) {
            let keys = document.getElementById(props.getKeyValue).value.split(",");
            if (keys.length === 1 && keys[0] === "") return;

            keys = keys.map(x => isNaN(Number(x)) ? x : Number(x));

            setSelectedKeys(keys);
            
        }
    }, [props.getKeyValue])

    const getDisplay = (opt) => {
        if (props.displayKey.includes(".")) {
            let keys = props.displayKey.split(".");

            let returnVal = opt[keys[0]];

            for (let i = 1; i < keys.length; i++) {
                returnVal = returnVal[keys[i]];
            }

            return returnVal;
        }

        return opt[props.displayKey]
    }

    return <>
        <input type="hidden" name={props.id} id={props.id} value={selectedKeys} />
        <div className="list-group">
            {
                props.options.map((opt, i) => {
                    return <button key={i} className={`list-group-item list-group-item-action ${selectedKeys.includes(typeof(opt) === "string" ? opt : opt.id) ? "active" : ""}`}
                                onClick={() => selectValue(typeof(opt) === "string" ? opt : opt.id)}>{typeof(opt) === "string" ? opt : getDisplay(opt)}</button>
                })
            }
        </div>
    </>
}

UIMultiselect.propTypes = {
    id: PropTypes.string,
    options: PropTypes.array,
    displayKey: PropTypes.string
}

export default UIMultiselect;